import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import clsx from "clsx";

const StudentHatIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={clsx("qi-icon qi-icon-student-hat", className)}
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <g xmlns="http://www.w3.org/2000/svg" clipPath="url(#clip0_126_1840)">
        <path
          d="M6.08354 6.36925L10.9577 4.25744C11.7285 3.92348 12.604 3.92798 13.3713 4.26983L21.9496 8.09165C22.7403 8.44393 22.7403 9.56627 21.9495 9.91855L19.6898 10.9253M3.43362 7.52576L2.1256 8.08929C1.32072 8.43606 1.31955 9.57686 2.12372 9.92527L4.86938 11.1148M4.86938 11.1148L10.9577 13.7526C11.7285 14.0866 12.6039 14.0821 13.3712 13.7402L19.6898 10.9253M4.86938 11.1148V17.621C4.86938 18.475 5.40954 19.2435 6.23402 19.466C10.2029 20.5374 14.6084 20.5238 18.3561 19.4757C19.1661 19.2491 19.6898 18.4884 19.6898 17.6474V10.9253"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M11.4398 9.4906L16.3949 12.3575L16.3948 16.1376"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};

export default memo(StudentHatIcon);
